import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeywordsService } from '../../../../../app/shared/API-Service/services/keywords.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-view-keywords',
  templateUrl: './view-keywords.component.html',
  styleUrls: ['./view-keywords.component.css']
})
export class ViewKeywordsComponent implements OnInit {

  constructor(private _KeywordsService:KeywordsService, private _Router:Router) { }
  keywords:object [] = [];
  ngOnInit(): void {
    this.getkeywords();
  }

  getkeywords(){
    this._KeywordsService.Getkeywords().subscribe((res) => {
      this.keywords = res.data
    console.log(this.keywords);
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._KeywordsService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertKeywords']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._KeywordsService.Deletekeywords(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getkeywords();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
